import { DateTime, Interval } from 'luxon'
//import fetch from 'cross-fetch'
export const RECEIVE_FM_PROGRAMS = 'RECEIVE_FM_PROGRAMS'
export const REQUEST_FM_PROGRAMS = 'REQUEST_FM_PROGRAMS'
export const INVALIDATE_FM_PROGRAMS = 'INVALIDATE_FM_PROGRAMS'
export const RECEIVE_ZD_PROGRAMS = 'RECEIVE_ZD_PROGRAMS'
export const REQUEST_ZD_PROGRAMS = 'REQUEST_ZD_PROGRAMS'
export const INVALIDATE_ZD_PROGRAMS = 'INVALIDATE_ZD_PROGRAMS'
export const REQUEST_PROGRAM = 'REQUEST_PROGRAM'
export const RECEIVE_PROGRAM = 'RECEIVE_PROGRAM'
export const SELECT_PROGRAM_SLUG = 'SELECT_PROGRAM_SLUG'
export const INVALIDATE_PROGRAM_SLUG = 'INVALIDATE_PROGRAM_SLUG'
export const REQUEST_EPISODES = 'REQUEST_EPISODES'
export const RECEIVE_EPISODES = 'RECEIVE_EPISODES'
export const REQUEST_EPISODE = 'REQUEST_EPISODE'
export const RECEIVE_EPISODE = 'RECEIVE_EPISODE'
export const CURRENT_EPISODE = 'CURRENT_EPISODE'
export const REQUEST_PLAYLISTS = 'REQUEST_PLAYLISTS'
export const RECEIVE_PLAYLISTS = 'RECEIVE_PLAYLISTS'
export const INVALIDATE_PLAYLISTS = 'INVALIDATE_PLAYLISTS'
export const WANTS_PLAYLIST = 'WANTS_PLAYLIST'
export const CURRENT_PLAYLIST = 'CURRENT_PLAYLIST'
export const SELECT_EPISODE_DATE = 'SELECT_EPISODE_DATE'
export const ON_AIR_FM = 'ON_AIR_FM'
export const ON_AIR_ZD = 'ON_AIR_ZD'
export const FM_LINEUP = 'FM_LINEUP'

export function invalidateFMPrograms() {
  return {
    type: INVALIDATE_FM_PROGRAMS
  }
}

function receiveFMPrograms(json) {
  return {
    type: RECEIVE_FM_PROGRAMS,
    programsFM: json,
    receivedAt: Date.now()
  }
}

function requestFMPrograms() {
  return {
    type: REQUEST_FM_PROGRAMS
  }
}

function fetchFMPrograms() {
  return dispatch => {
    dispatch(requestFMPrograms())
    return fetch('https://4zzz.org.au/airnetapi/rest/stations/4ZZZ/guides/fm')
      .then(response => response.json())
      .then(json => {
        dispatch(receiveFMPrograms(json))
      })
  }
}

function receiveOnAirFM(program, key) {
  return {
    type: ON_AIR_FM,
    program: program,
    key: key
  }
}
export function onAirFM() {
  return (dispatch, getState) => {
    return dispatch(
      fetchFMProgramsIfNeeded()
    ).then(() => {
      const state = getState()
      let now =  DateTime.local().setZone("Australia/Brisbane")
      // let day = ((now.day + 6) % 7) + 1
      let day = now.weekday;
      let datestring = now.toISODate()

      // let now =  moment().tz("Australia/Brisbane")
      // let day = ((now.day() + 6) % 7) + 1
      // let datestring = now.format('YYYY-MM-DD')

      state.programsFM.items.forEach((fm, index) => {
        if (fm.day == day) {
          let starttime = DateTime.fromSQL(datestring + ' ' + fm.start  + '+10:00')
          let endtime = starttime.plus({seconds: fm.duration})
          if (Interval.fromDateTimes(starttime, endtime).contains(now) ) {
           dispatch(receiveOnAirFM(fm, index))
          }
        }
      })
    })
  }
}

function shouldFetchFMPrograms(state) {
  const programsFM = state.programsFM
  if (programsFM.isFetching) {
    return false
  } else if (programsFM.items.length === 0) {
    return true
  } else {
    return programsFM.didInvalidate
  }
}

export function fetchFMProgramsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchFMPrograms(getState())) {
      return dispatch(fetchFMPrograms())
    }
    else {
      let check = new Promise((resolve, reject) => {
        var wait = () => {
          if (getState().programsFM.isFetching) {
            setTimeout(wait, 100)
          }
          else {
            resolve('FM Fetched')
          }
        }
        setTimeout(wait, 200)
      })
      return check
    }
  }
}

export function invalidateZDPrograms() {
  return {
    type: INVALIDATE_ZD_PROGRAMS
  }
}

function receiveOnAirZD(program, key) {
  return {
    type: ON_AIR_ZD,
    program: program,
    key: key
  }
}
export function onAirZD() {
  return (dispatch, getState) => {
    return dispatch(
      fetchZDProgramsIfNeeded()
    ).then(() => {
      const state = getState()
      let now =  DateTime.local().setZone("Australia/Brisbane")
      let day = now.weekday;
      let datestring = now.toISODate()

      state.programsZD.items.forEach((fm, index) => {
        if (fm.day == day) {
          let starttime = DateTime.fromSQL(datestring + ' ' + fm.start  + '+10:00')
          let endtime = starttime.plus({seconds: fm.duration})
          if (Interval.fromDateTimes(starttime, endtime).contains(now) ) {
            return dispatch(receiveOnAirZD(fm, index))
          }
        }
      })
    })
  }
}


function receiveZDPrograms(json) {
  return {
    type: RECEIVE_ZD_PROGRAMS,
    programsZD: json,
    receivedAt: Date.now()
  }
}

function requestZDPrograms() {
  return {
    type: REQUEST_ZD_PROGRAMS
  }
}

function fetchZDPrograms() {
  return dispatch => {
    dispatch(requestZDPrograms())
    return fetch('https://4zzz.org.au/airnetapi/rest/stations/4ZZZ/guides/digital')
      .then(response => response.json())
      .then(json => {
        dispatch(receiveZDPrograms(json))
      })
  }
}

function shouldFetchZDPrograms(state) {
  const programsZD = state.programsZD
  if (programsZD.isFetching) {
    return false
  } else if (programsZD.items.length === 0) {
    return true
  } else {
    return programsZD.didInvalidate
  }
}

export function fetchZDProgramsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchZDPrograms(getState())) {
      return dispatch(fetchZDPrograms())
    }
    else {
      let check = new Promise((resolve, reject) => {
        var wait = () => {
          if (getState().programsZD.isFetching) {
            setTimeout(wait, 100)
          }
          else {
            resolve('ZD Fetched')
          }
        }
        setTimeout(wait, 200)
      })
      return check
    }
  }
}
 
export function selectProgramSlug(slug) {
  return {
    type: SELECT_PROGRAM_SLUG,
    slug
  }
}
 
export function invalidateProgramSlug(slug) {
  return {
    type: INVALIDATE_PROGRAM_SLUG,
    slug
  }
}
 
function requestProgram(slug) {
  return {
    type: REQUEST_PROGRAM,
    slug
  }
}
 
function receiveProgram(slug, json) {
  return {
    type: RECEIVE_PROGRAM,
    slug,
    program: json,
    receivedAt: Date.now()
  }
}
 
function fetchProgram(slug) {
  return (dispatch, getState) => {
    dispatch(requestProgram(slug))
    return Promise.all([
      dispatch(fetchZDProgramsIfNeeded()),
      dispatch(fetchFMProgramsIfNeeded())
    ]).then( (data) => {
      let programs = getState().programsFM.items.concat( getState().programsZD.items )
      let programSchedule = programs.filter(function(haystack){ return haystack.slug === slug})
       return fetch(`https://4zzz.org.au/airnetapi/rest/stations/4ZZZ/programs/${slug}`)
      .then(response => response.json())
      .then(json => dispatch(receiveProgram(slug, { ...json, schedule: programSchedule })))
    }
    )
  }
}
 
function shouldFetchProgram(state, slug) {
  const program = state.programs[slug]
  if (!program) {
    return true
  } else if (program.program.isFetching) {
    return false
  } else {
    return program.program.didInvalidate
  }
}
 
export function fetchProgramIfNeeded(slug) {
  return (dispatch, getState) => {
    if (shouldFetchProgram(getState(), slug)) {
      return dispatch(fetchProgram(slug))
    }
    else {
      let check = new Promise((resolve, reject) => {
        var wait = () => {
          if (getState().programs[slug].program.isFetching) {
            setTimeout(wait, 100)
          }
          else {
            resolve('Program Fetched')
          }
        }
        setTimeout(wait, 200)
      })
      return check
    }
  }
}


function requestEpisodes(slug) {
  return {
    type: REQUEST_EPISODES,
    slug
  }
}
 
function receiveEpisodes(slug, json) {
  return {
    type: RECEIVE_EPISODES,
    slug,
    items: json,
    receivedAt: Date.now()
  }
}

function setCurrentEpisode(slug, episode, key){
  return {
    type: CURRENT_EPISODE,
    slug,
    episode,
    key
  }
}

function fetchEpisodes(slug) {
  return (dispatch, getState) => {
    dispatch(requestEpisodes(slug))
    return fetch(`https://4zzz.org.au/airnetapi/rest/stations/4ZZZ/programs/${slug}/episodes`)
      .then(response => response.json())
      .then(json => {
        dispatch(receiveEpisodes(slug, json))
        const state = getState()
        if (state.selectedEpisodeDate) {
          //dispatch(canHasPlaylist(state.selectedEpisodeDate))
        }
        else{
          dispatch(selectEpisodeDate(json[json.length - 1].start))
        }
      })
      .catch( error => console.log('problem'))
  }
}

function shouldFetchEpisodes(state, slug) {
  const program = state.programs[slug]
  if (!program.episodes || !program.episodes.episodeIndex ) {
    return true
  } else if (program.episodes.isFetching) {
    return false
  } else {
    return program.episodes.didInvalidate
  }
}
 
export function fetchEpisodesIfNeeded(slug) {
  return (dispatch, getState) => {
    if (shouldFetchEpisodes(getState(), slug)) {
      return dispatch(fetchEpisodes(slug))
    }
    else {
      let check = new Promise((resolve, reject) => {
        var wait = () => {
          if (getState().programs[slug].episodes.isFetching) {
            setTimeout(wait, 100)
          }
          else {
            resolve('Episodes Fetched')
          }
        }
        setTimeout(wait, 200)
      })
      return check
    }
  }
}

export function programWithEpisode(slug, datestring) {
  return (dispatch) => {
    return Promise.all([
      dispatch(selectProgramSlug(slug)),
      dispatch(selectEpisodeDate(datestring))
    ]).then( () =>
      Promise.all([
        dispatch(fetchProgramIfNeeded(slug)),
        dispatch(fetchEpisodeIfNeeded(slug, datestring))
      ])
    )
  }
}

export function programEpisodeWithPlaylist(slug, datestring) {
  return (dispatch, getState) => {
    if(getState().selectedEpisodeDate.indexOf(datestring) != -1)  {
      datestring = getState().selectedEpisodeDate
    }
    return dispatch(programWithEpisode(slug, datestring)).then( () =>
      dispatch(fetchPlaylistsIfNeeded(slug, datestring))
    )
  }
}

export function invalidatePlaylists(slug, starttime) {
  return {
    type: INVALIDATE_PLAYLISTS,
    slug,
    starttime
  }
}

function requestPlaylists(slug, starttime) {
  return {
    type: REQUEST_PLAYLISTS,
    slug,
    starttime
  }
}
 
function receivePlaylists(slug, starttime, json) {
  return {
    type: RECEIVE_PLAYLISTS,
    slug,
    starttime,
    items: json,
    receivedAt: Date.now()
  }
}

// function fetchEpisode(slug, date) {
//   return (dispatch, getState) => {
//     dispatch(requestEpisode(slug, date))
//     return dispatch(fetchProgramIfNeeded(slug)).then(
//       () => {
//          console.log(getState().programs[slug].program)
//          let time =  getState().programs[slug].program.schedule[0].start
//          fetch(`//4zzz.org.au/airnetapi/rest/stations/4ZZZ/programs/${slug}/episodes/${date} ${time}`)
//            .then(response => response.json())
//            .then(json => {
//              dispatch(receiveEpisode(slug, date + ' ' + time, json))
//              dispatch(selectEpisodeDate(date + ' ' + time))
//           })
//       }
//     )
//   }
// }

function fetchPlaylists(slug, starttime) {
  return (dispatch, getState) => {
    dispatch(requestPlaylists(slug, starttime))
    return dispatch(fetchProgramIfNeeded(slug)).then( () => {
			starttime = decodeURI(starttime)
			let schedule = getState().programs[slug].program.schedule;
			let time = undefined;
      if(starttime.split(' ').length === 1) {
				if (schedule.length && schedule[0].start)
					starttime = starttime + ' ' + schedule[0].start
       } else {
        //starttime = starttime.split(' ')[0] + ' ' + time
      }

      return fetch(`https://4zzz.org.au/airnetapi/rest/stations/4ZZZ/programs/${slug}/episodes/${starttime}/playlists`)
      .then(response => response.json())
      .then(json => dispatch(receivePlaylists(slug, starttime, json)))
			.catch((error) => {
			  console.error('Error:', error);
			});
    })
  }
}

function currentPlaylist(slug, starttime) {
  return {
    type: CURRENT_PLAYLIST,
    slug,
    starttime
  }
}
 
function shouldFetchPlaylists(state, slug, starttime) {
  const program = state.programs[slug]
  if (!program.playlists) {
    return true
  } else if (!program.playlists[starttime]) {
    return true
  } else if (program.playlists[starttime].isFetching) {
    return false
  } else {
    return program.playlists[starttime].didInvalidate
  }
}
 
export function fetchPlaylistsIfNeeded(slug, starttime) {
  return (dispatch, getState) => {
    if (shouldFetchPlaylists(getState(), slug, starttime)) {
      return dispatch(fetchPlaylists(slug, starttime))
    }
    else {
      return dispatch(currentPlaylist(slug, starttime))
    }
  }
}



/*function canHasPlaylist(date) {
  return (dispatch, getState) => {
    const state = getState()
    if (state.programs[state.selectedProgramSlug] && state.programs[state.selectedProgramSlug].episodes.items.length > 0) {
      const program = state.programs[state.selectedProgramSlug]

      if (date) {
        program.episodes.items.forEach(function(val, key){
          if(val.start.search(date) !== -1) {
            dispatch(setCurrentEpisode(state.selectedProgramSlug, val, key))
            dispatch(fetchPlaylistsIfNeeded(state.selectedProgramSlug, val.start))
          }
        })
      }
      else {
        dispatch(setCurrentEpisode(state.selectedProgramSlug, program.episodes.items[program.episodes.items.length - 1], program.episodes.items.length - 1))
        dispatch(fetchPlaylistsIfNeeded(state.selectedProgramSlug, program.episodes.items[program.episodes.items.length - 1].start))
      }
    } else {
      return dispatch(deferFetchPlaylist(date))
    }
  }
}*/

function canHasPlaylist(date) {
  return (dispatch, getState) => {
    const slug = getState().selectedProgramSlug
    Promise.all([
      dispatch(fetchProgramIfNeeded(slug)),
      dispatch(fetchEpisodesIfNeeded(slug))
    ]).then( () => {
      const program = getState().programs[slug]
      var episode, episodeKey
      if(date) {
        program.episodes.items.forEach(function(val, key){
          if(val.start.search(date) !== -1) {
            episodeKey = key
            episode = val
          }
        })
        if (!episodeKey && !episode) {
          episode = program.episodes[date]
          episodeKey = null
        }
        //debugger
      }
      else{
        episodeKey = program.episodes.items.length -1
        episode = program.episodes.items[episodeKey]
      }
      Promise.all([
        dispatch(setCurrentEpisode(slug, episode, episodeKey)),
        dispatch(fetchPlaylistsIfNeeded(slug, episode.start))
      ])
    })
  }
}

export function programEpisodes(){
  return (dispatch, getState) => {
    const slug = getState().selectedProgramSlug
    return Promise.all([
      dispatch(fetchProgramIfNeeded(slug)),
      dispatch(fetchEpisodesIfNeeded(slug))
    ])
  }
}

export function fetchFortyFive() {
	return (dispatch, getState) => {
		return Promise.all([dispatch(fetchProgramIfNeeded('45-years-of-the-zeds')), dispatch(programEpisodeWithPlaylist('45-years-of-the-zeds',  '2020-12-08')) ])
	}
}
export function fmLineup(){
	return (dispatch, getState) => {
		let state = getState();
		const {programs, programsFM, onAirFM} = state;
		// console.log(state)
		if(onAirFM.key && programsFM.items.length) {
			let shows = [
				{...programsFM.items[onAirFM.key - 1 >= 0 ? onAirFM.key - 1 : programsFM.items.length -1],  plasylist: false, title: 'Previously...', reverse: true, height: '80vh' },
				{...programsFM.items[onAirFM.key], playlist: true, title: 'On-air now!', onairnow: true, reverse: true, height: '95vh'},
				{...programsFM.items[programsFM.items.length -1 >= onAirFM.key + 1 ? onAirFM.key + 1 : 0], playlist: false, title: 'Up next', reverse: true, height: '80vh'}
			]
			let datestring = DateTime.local().setZone("Australia/Brisbane").toISODate()

      let promises = []
			shows.forEach((item) => {
				if (! programs[item.slug]) {
					promises.push(
            dispatch(programEpisodeWithPlaylist(item.slug, datestring))
          )
				}
			})

      return Promise.all(promises).then(
        () => {
          dispatch(setFMLineup(shows));
        }
      )
		}
	}

}

function setFMLineup(shows) {
	return {
		type: FM_LINEUP,
		shows
	}
}

export function programEpisodesWithCurrentPlaylist(){
  return (dispatch, getState) => {
    const slug = getState().selectedProgramSlug
    return Promise.all([
      dispatch(fetchProgramIfNeeded(slug)),
      dispatch(fetchEpisodesIfNeeded(slug))
    ]).then( () => {
      const episodes = getState().programs[slug].episodes
      if(!episodes.episodeIndex)
        return
      let episodeIndex = episodes.episodeIndex.length -1
      let episodeKey = episodes.episodeIndex[episodeIndex]  
      let episode = episodes[episodeKey]

      return Promise.all([
        dispatch(selectEpisodeDate(episode.start)),
        dispatch(setCurrentEpisode(slug, episode, episodeKey)),
        dispatch(fetchPlaylistsIfNeeded(slug, episode.start))
      ])
    })
  }
}

function deferFetchPlaylist(date) {
  if(date === undefined) {
    date = null
  }
  return {
    type: SELECT_EPISODE_DATE,
    date
  }
}

export function selectEpisodeDate(date) {
  if(date === undefined) {
    date = null
  }
  return {
    type: SELECT_EPISODE_DATE,
    date
  }
}


function requestEpisode(slug, date) {
  return {
    type: REQUEST_EPISODE,
    slug,
    date
  }
}
 
function receiveEpisode(slug, date, json) {
  return {
    type: RECEIVE_EPISODE,
    slug,
    date,
    episode: json,
    receivedAt: Date.now()
  }
}


function fetchEpisode(slug, date) {
  return (dispatch, getState) => {
    dispatch(requestEpisode(slug, date))
    return dispatch(fetchProgramIfNeeded(slug)).then(
      () => {
        let schedule = getState().programs[slug].program.schedule;
				let time = undefined;
				date = decodeURI(date)
				if (date.split(' ').length === 1) {
	        if (schedule.length && schedule[0].start) {
	          time = schedule[0].start;
	        } else {
	          dispatch(fetchEpisodesIfNeeded(slug)).then(
	            () => {
	              console.log("THEN!")
	            }
	          )
	          time = '';
	        }
	         // let time =  getState().programs[slug].program.schedule[0].start
	         if(date.split(' ').length === 1) {
	           date = date + ' ' + time
	         } else {
	           date = date.split(' ')[0] + ' ' + time
	         }
			 	}
				else {
					console.log(date)
				}
        fetch(`https://4zzz.org.au/airnetapi/rest/stations/4ZZZ/programs/${slug}/episodes/${date}`)
        .then(response => response.json())
        .then(json => {
          dispatch(receiveEpisode(slug, date, json))
          dispatch(selectEpisodeDate(date))
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
    )
  }
}

function shouldFetchEpisode(state, date, slug) {
  const program = state.programs[slug]
  if (!program.episodes || !program.episodes[date] ) {
    return true
  } else if (program.episodes[date].isFetching) {
    return false
  } else {
    return program.episodes[date].didInvalidate
  }
}
 
export function fetchEpisodeIfNeeded(slug, date) {
  return (dispatch, getState) => {
    if (shouldFetchEpisode(getState(), date, slug)) {
      return dispatch(fetchEpisode(slug, date))
    }
    else {
      let check = new Promise((resolve, reject) => {
        var wait = () => {
          if (getState().programs[slug].episodes[date].isFetching) {
            setTimeout(wait, 100)
          }
          else {
            resolve('Episode Fetched')
          }
        }
        setTimeout(wait, 200)
      })
      return check
    }
  }
}
